/**
 * Safely retrieves a URL search parameter, returning undefined for
 * missing, empty, or malformed params (e.g., `?key` without `=`).
 *
 * This is needed because the Everflow SDK's `EF.urlParameter()` returns
 * an empty string for malformed params like `?_ef_transaction_id&uid=2599`,
 * which prevents the organic fallback from generating a transaction ID.
 */
export function getSafeUrlParam(
  name: string,
  search = window.location.search,
): string | undefined {
  const value = new URLSearchParams(search).get(name)?.trim();
  return value || undefined;
}
